define("shared/components/shared/social/instagram-modal/unavailable-page", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <li class="u--flex u--flex__justify--between u--flex__alignItems--center u--m__b u--mute">
    <div class="o--user">
      <span class="o--user__avatarProfile">
        <img
          alt={{or @page.name_with_location_descriptor @page.name}}
          class="o--user__avatar"
          src={{or @page.picture.data.url "/assets/images/img--userAvatar--placeholder.svg"}}
        />
      </span>
      <span class="o--user__avatarChild--facebook">
        <i class="i--facebook--w"></i>
      </span>
      <span class="o--user__title">
        <span class="u--ellipsis">{{or @page.name_with_location_descriptor @page.name}}</span>
      </span>
      <span class="o--user__desc">{{t "credentials.instagram_modal.body.unavailable.facebook_page"}}</span>
    </div>
    {{#if (@unavailableReason @page)}}
      <span class="u--text--right u--m__l__lg">{{@unavailableReason @page}}</span>
    {{/if}}
  </li>
  */
  {
    "id": "Lc74FxrZ",
    "block": "[[[10,\"li\"],[14,0,\"u--flex u--flex__justify--between u--flex__alignItems--center u--m__b u--mute\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--user\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"o--user__avatarProfile\"],[12],[1,\"\\n      \"],[10,\"img\"],[15,\"alt\",[28,[37,0],[[30,1,[\"name_with_location_descriptor\"]],[30,1,[\"name\"]]],null]],[14,0,\"o--user__avatar\"],[15,\"src\",[28,[37,0],[[30,1,[\"picture\",\"data\",\"url\"]],\"/assets/images/img--userAvatar--placeholder.svg\"],null]],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[14,0,\"o--user__avatarChild--facebook\"],[12],[1,\"\\n      \"],[10,\"i\"],[14,0,\"i--facebook--w\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[14,0,\"o--user__title\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--ellipsis\"],[12],[1,[28,[35,0],[[30,1,[\"name_with_location_descriptor\"]],[30,1,[\"name\"]]],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[14,0,\"o--user__desc\"],[12],[1,[28,[35,1],[\"credentials.instagram_modal.body.unavailable.facebook_page\"],null]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[28,[30,2],[[30,1]],null],[[[1,\"    \"],[10,1],[14,0,\"u--text--right u--m__l__lg\"],[12],[1,[28,[30,2],[[30,1]],null]],[13],[1,\"\\n\"]],[]],null],[13]],[\"@page\",\"@unavailableReason\"],false,[\"or\",\"t\",\"if\"]]",
    "moduleName": "shared/components/shared/social/instagram-modal/unavailable-page.hbs",
    "isStrictMode": false
  });
  class UnvailableProfileComponent extends _component2.default {}
  _exports.default = UnvailableProfileComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, UnvailableProfileComponent);
});